import React, { PureComponent } from "react";
import styled from "styled-components";
import SelectorArrowIcon from "containers/assets/icon-dropdown-arrow-filled.svg";

const TeamSelectorContainer = styled.div`
  position: relative;
`;

const SelectedOptionWrapper = styled.div`
  border: 2px solid #5C91F5;
  border-radius: 4px;
  width: 180px;
  padding: 6px 40px 6px 16px;
  color: #5C91F5;
  cursor: pointer;
  font-family: 'Mukta Vaani';
  font-size: 16px;
  line-height: 16px;
`;

const TeamSelectorArrow = styled.div`
  width: 32px;
  height: 32px;
  background-color: #5C91F5;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

const TeamSelectorItemsWrapper = styled.div`
  z-index: 1;
  position: absolute;
  display: none;
  left: 0;
  right: 0;
  width: 100%;

  ${p =>
    p.isShown &&
    `
    display: block;
  `}
`;

const TeamSelectorItems = styled.ul`
  width: 100%;
  border: 3px solid #ffffff;
  border-radius: 5px;
  list-style: none;
  font-weight: 800;
  color: #ffffff;
  background-color: #2a4169;
  padding: 0;
  max-height: 300px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 3px;
  }
   
  &::-webkit-scrollbar-thumb {
    background: #5C91F5; 
  }

  li {
    cursor: pointer;
    padding: 6px 16px;
  }

  li:hover {
    color: #2a4169;
    background: #fff;
  }
`;

class TeamSelector extends PureComponent {
  constructor(props) {
    super(props);

    this.currentRef = null;
    this.currentRef2 = null;

    this.state = {
      menuShown: false
    };
  }

  componentDidMount() {
    if (window) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (window) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  handleClickOutside = e => {
    let clicked1 = false;
    if (this.currentRef && this.currentRef.contains(e.target)) {
      clicked1 = true;
    }

    let clicked2 = false;
    if (this.currentRef2 && this.currentRef2.contains(e.target)) {
      clicked2 = true;
    }

    if (!clicked1 && !clicked2) {
      this.setState({
        menuShown: false
      });
    }
  };

  toggleMenu = () => {
    this.setState({
      menuShown: !this.state.menuShown
    });
  };

  render() {
    const { menuShown } = this.state;
    const { options, onSelectorChange, selectedOptionId } = this.props;

    const sortedOptions = [...options].sort((a, b) => a.name.localeCompare(b.name));

    return (
      <TeamSelectorContainer>
        <SelectedOptionWrapper
          innerRef={node => (this.currentRef = node)}
          onClick={this.toggleMenu}
        >
          <span>{selectedOptionId ? options.find(i => i.id === selectedOptionId).name : options[0].name}</span>
          <TeamSelectorArrow>
            <img src={SelectorArrowIcon} alt="arrow" />
          </TeamSelectorArrow>
        </SelectedOptionWrapper>
        <TeamSelectorItemsWrapper
          innerRef={node => (this.currentRef2 = node)}
          isShown={menuShown}
        >
          <TeamSelectorItems>
            {sortedOptions.map((option, index) => {
              return (
                <li
                  onClick={() => {
                    onSelectorChange(option.id);
                    this.toggleMenu();
                  }}
                  value={option.id}
                  key={index}
                >
                  {option.name}
                </li>
              );
            })}
          </TeamSelectorItems>
        </TeamSelectorItemsWrapper>
      </TeamSelectorContainer>
    );
  }
}

export default TeamSelector;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/components/team-selector.js